import React from 'react';

export const MOODS = [
  { id: 'vibrant',     label: 'Vibrant 🌈',    hint: 'vibrant, saturated colors, bold and colorful',           color: 'linear-gradient(135deg, #f97316, #ec4899, #8b5cf6)' },
  { id: 'dark',        label: 'Dark 🌑',        hint: 'dark and moody, deep shadows, dramatic lighting',        color: 'linear-gradient(135deg, #1e1e2e, #374151)' },
  { id: 'pastel',      label: 'Pastel 🌸',      hint: 'soft pastel colors, dreamy and gentle, light palette',   color: 'linear-gradient(135deg, #fca5a5, #fdba74, #a5f3fc)' },
  { id: 'neon',        label: 'Neon ⚡',        hint: 'neon glow effects, electric colors on dark background',  color: 'linear-gradient(135deg, #00ffff, #ff00ff)' },
  { id: 'mono',        label: 'Mono ⬛',        hint: 'monochromatic, black and white, grayscale tones',        color: 'linear-gradient(135deg, #9ca3af, #111827)' },
  { id: 'watercolor',  label: 'Watercolor 🎨',  hint: 'watercolor painting style, soft washes, hand-painted',  color: 'linear-gradient(135deg, #60a5fa, #34d399, #f472b6)' },
  { id: 'vintage',     label: 'Vintage 📷',     hint: 'vintage retro style, faded colors, old school aesthetic', color: 'linear-gradient(135deg, #d97706, #92400e)' },
];

export function applyMood(prompt, moodId) {
  if (!moodId) return prompt;
  const mood = MOODS.find(m => m.id === moodId);
  if (!mood) return prompt;
  return `${prompt}, ${mood.hint}`;
}

function MoodSelector({ activeMood, onSelect, disabled }) {
  return (
    <div className="mood-selector">
      <span className="mood-label">Style mood</span>
      <div className="mood-chips">
        {MOODS.map(mood => (
          <button
            key={mood.id}
            type="button"
            className={`mood-chip${activeMood === mood.id ? ' active' : ''}`}
            style={{ '--mood-bg': mood.color }}
            onClick={() => onSelect(activeMood === mood.id ? null : mood.id)}
            disabled={disabled}
            title={`Apply ${mood.label.replace(/\s\S+$/, '')} style`}
          >
            {mood.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default MoodSelector;
